import { useState, useCallback } from 'react';
import { readJSON, writeJSON } from '../../../hooks/usePersistentState';

export const useDimensionControl = (
  options: string[],
  initialIndex: number,
  /** When set, the selected index is cached in localStorage under this key. */
  persistKey?: string
) => {
  const [currentIndex, setCurrentIndex] = useState(() => {
    if (!persistKey) return initialIndex;
    const stored = readJSON<number | null>(persistKey, null);
    return typeof stored === 'number' && stored >= 0 && stored < options.length
      ? stored
      : initialIndex;
  });

  const increase = useCallback(() => {
    setCurrentIndex(prevIndex => {
      const next = Math.min(prevIndex + 1, options.length - 1);
      if (persistKey) writeJSON(persistKey, next);
      return next;
    });
  }, [options.length, persistKey]);

  const decrease = useCallback(() => {
    setCurrentIndex(prevIndex => {
      const next = Math.max(prevIndex - 1, 0);
      if (persistKey) writeJSON(persistKey, next);
      return next;
    });
  }, [persistKey]);

  return {
    currentValue: options[currentIndex],
    increase,
    decrease,
  };
};
